// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O1wp","newExpiryDate":"styles_newExpiryDate__2s_7e","footer":"styles_footer__K_YkD"};